import type { CreatePropertyInput, UpdatePropertyInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type { IProperty } from '../models/property'
import type { PaginatedProperties, PropertiesAdminParams } from '../models/property-admin'

export async function getPropertiesAdmin(
  params: PropertiesAdminParams
): Promise<PaginatedProperties> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedProperties>(
    `${API.properties.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/**
 * Los payloads son los MISMOS schemas Zod que valida el backend
 * (@idc-forms/schemas → nestjs-zod): un solo contrato de validación.
 */
export async function createProperty(payload: CreatePropertyInput): Promise<IProperty> {
  const { data } = await axiosPrivate.post<IProperty>(API.properties.root, payload)
  return data
}

export async function updateProperty(id: string, payload: UpdatePropertyInput): Promise<IProperty> {
  const { data } = await axiosPrivate.patch<IProperty>(API.properties.byId(id), payload)
  return data
}

export async function deleteProperty(id: string) {
  const { data } = await axiosPrivate.delete(API.properties.byId(id))
  return data
}
